module.exports = __webpack_public_path__ + "assets/img/NPC019.f6260e55.png";